"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatNextInspection = exports.default = void 0;
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var TIMEZONE = 'Australia/Sydney';
var formatNextInspection = property => {
  if (property.listing.nextInspection && !(0, _isEmpty.default)(property.listing.nextInspection)) {
    var newProperty = _objectSpread({}, property);
    newProperty.listing.nextInspection = {
      startdate: _momentTimezone.default.tz(property.listing.nextInspection.startdate, TIMEZONE).format().substring(0, 19),
      id: property.listing.nextInspection.id
    };
    return newProperty;
  }
  return property;
};
exports.formatNextInspection = formatNextInspection;
var _default = exports.default = formatNextInspection;